import { categories } from "@/mocks/categories";

export default function CategoriesSection() {
  return (
    <section id="categories-section" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-apps-2-line"></i>
            All Categories
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight mb-4">
            Browse Every Pandabuyspreadsheet
            <br />
            Category
          </h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto leading-relaxed">
            All 14 organized categories with direct links to the full pandabuyspreadsheet comparison
            tables on our main hub. Each category is curated daily with fresh finds.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex items-center gap-3 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-300 hover:bg-accent-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-accent-600 text-base`}></i>
              </div>
              <div className="flex flex-col min-w-0">
                <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-400 truncate">{cat.description}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}